import React from "react";
import { RemoveScroll } from "react-remove-scroll";
import ReactDom from "react-dom";
import { RiCloseCircleLine } from "react-icons/ri";
import Base64ToPDFViewer from "../../../Components/PdfImageConverter";

const PreviewModal = ({ open, handleClose, data }) => {
    if (!open) return null;

    return ReactDom.createPortal(
        <div className='fixed top-0 left-0 right-0 h-screen bg-black/40 overflow-clip'>
            <RemoveScroll className='flex justify-center h-full flex-col p-10'>
                <button
                    type='button'
                    onClick={handleClose}
                    className='place-self-end p-2 absolute top-10 inset-x-10 text-white'
                >
                    <RiCloseCircleLine className='text-white/90 hover:text-white text-2xl' />
                </button>
                {data && <Base64ToPDFViewer base64String={data} />}
            </RemoveScroll>
        </div>,
        document.getElementById("portal")
    );
};

export default PreviewModal;
